import { CheckCircleOutlined } from '@ant-design/icons';
import { styled } from 'styled-components';

export const SuccessIcon = styled(CheckCircleOutlined)`
  color: #52c41a;
  font-size: 20px;
`;
